import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";
import { ProtectedRoute } from "./components";
import PrivacyPolicy from "./components/privaceyPolicey/PrivacyPolicy";
import {
  Admin,
  AdvertiseManagement,
  AthleteManagement,
  CollegeManagement,
  InvitationSignup,
  LiveScoreManagement,
  Login,
  NewsManagement,
  NilNewsManagement,
  Profile,
  RaffleSettings,
  RecruitNewsManagement,
  SettingsManagement,
  SignUp,
  SportManagement,
  TransferNewsManagement,
  UserManagement,
} from "./pages";
import TermandConditions from "./pages/TermandConditions/TermandConditions";
import BannersManagement from "./pages/bannersManagment/bannersManagment";
import Chat from "./pages/chat/Chat";
import UniversitySportsManagementPage from "./pages/collegemanagement/UniversitySportsManagement";
import ForumDetail from "./pages/forumDetail/ForumDetail";
import ForumManagement from "./pages/forumManagment/forumManagment";
import ForumList from "./pages/forumlist/ForumList";
import Updsteprofil from "./pages/forumlist/updsteprofil";
import GamePlayManagement from "./pages/gamePlayManagement/gamplayManagement";
import Home from "./pages/home/Home";
import KeyManagement from "./pages/keyManagement/keyManagement";
import MemberForm from "./pages/profiledata/MemberForm";
import { AuthProvider } from "./store/context/authContext";
import { ForumProvider } from "./components/context/ForumContext";
import { ThemeProvider } from "./components/context/ThemeContext";
import Membership from "./components/Membership/Membership";
import "react-toastify/dist/ReactToastify.css";
import MessagesManagment from "./pages/messagesManagment/messagesManagment";
import NewsLinkManagement from "./pages/NewslinkManagement/NewsLinkManagement";
import Payment from "./components/Membership/Payment";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import NewsTop25Management from "./pages/NewsTop25Management/NewsTop25Management";
import StatsManagement from "./pages/StatsManagement/StatsManagement";
import AutoNewsStatistics from "./pages/AutoNewsStatistics/AutoNewsStatistics";
import Contact from "./components/contact/Contact";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
// console.log("stripekey",process.env.REACT_APP_STRIPE_PUBLIC_KEY)
function App() {
  return (
    <>
      <ToastContainer autoClose={2000} />
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <ForumProvider>
              <Routes>
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <Admin />
                    </ProtectedRoute>
                  }
                >
                  <Route
                    path="advertise_management"
                    element={
                      <ProtectedRoute>
                        <AdvertiseManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="key_management"
                    element={
                      <ProtectedRoute>
                        <KeyManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="Auto_news_statistics"
                    element={
                      <ProtectedRoute>
                        <AutoNewsStatistics />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="user_management"
                    element={
                      <ProtectedRoute>
                        <UserManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="colleges_management"
                    element={
                      <ProtectedRoute>
                        <CollegeManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="stats_management"
                    element={
                      <ProtectedRoute>
                        <StatsManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="athlete_management"
                    element={
                      <ProtectedRoute>
                        <AthleteManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="banners_management"
                    element={
                      <ProtectedRoute>
                        <BannersManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="settings_management"
                    element={
                      <ProtectedRoute>
                        <SettingsManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="messages_management"
                    element={
                      <ProtectedRoute>
                        <MessagesManagment />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="forum_management"
                    element={
                      <ProtectedRoute>
                        <ForumManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="sports_management"
                    element={
                      <ProtectedRoute>
                        <UniversitySportsManagementPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="sport_management"
                    element={
                      <ProtectedRoute>
                        <SportManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="raffle_management"
                    element={
                      <ProtectedRoute>
                        <RaffleSettings />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="recruitnews_management"
                    element={
                      <ProtectedRoute>
                        <RecruitNewsManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="gameplay_management"
                    element={
                      <ProtectedRoute>
                        <GamePlayManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="news_link"
                    element={
                      <ProtectedRoute>
                        <NewsLinkManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="news_Top25"
                    element={
                      <ProtectedRoute>
                        <NewsTop25Management />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="nilnews_management"
                    element={
                      <ProtectedRoute>
                        <NilNewsManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="transfernews_management"
                    element={
                      <ProtectedRoute>
                        <TransferNewsManagement />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="news_management"
                    element={
                      <ProtectedRoute>
                        <NewsManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="livescores_management"
                    element={
                      <ProtectedRoute>
                        <LiveScoreManagement />
                      </ProtectedRoute>
                    }
                  />
                </Route>

                <Route
                  path="termand-conditions"
                  element={
                    <ProtectedRoute>
                      <TermandConditions />
                    </ProtectedRoute>
                  }
                />

                <Route path="/login" element={<Login />} />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route path="/signup" element={<SignUp />} />
                <Route
                  path="/memberform"
                  element={
                    <ProtectedRoute>
                      <MemberForm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/updateprofile"
                  element={
                    <ProtectedRoute>
                      <Updsteprofil />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/membership"
                  element={
                    <ProtectedRoute>
                      <Membership />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payment"
                  element={
                    <Elements
                      stripe={stripePromise}
                      options={{ mode: "setup", currency: "usd" }}
                    >
                      <Payment />
                    </Elements>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="forumdetail/:id"
                  element={
                    <ProtectedRoute>
                      <ForumDetail />
                    </ProtectedRoute>
                  }
                />
                {/* <Route path="/invitation/:id" element={<InvitationSignup />} /> */}
                <Route path="/invitation/:id" element={<SignUp />} />

                <Route
                  path="forumlist"
                  element={
                    <ProtectedRoute>
                      <ForumList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="chat"
                  element={
                    <ProtectedRoute>
                      <Chat />
                    </ProtectedRoute>
                  }
                />
                <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
                <Route path="contact" element={<Contact />} />
              </Routes>
            </ForumProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}
export default App;
